<template>
  <div class="home">
    <h2 class="mt-5 fw-bold">Kampanyalar</h2>
    <div class="campaigns">
      <div
        v-for="campaign in campaigns"
        :key="campaign.id"
        :id="campaign.id"
        class="campaign-card"
        @click="goToCampaignDetail(campaign.id)"
      >
        <img :src="campaign.image" :alt="campaign.name" />
        <h3 class="campaign-title">{{ campaign.title }}</h3>
        <div class="campaign-dates">
          <span>{{ campaign.start }}</span> - <span>{{ campaign.end }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      campaigns: [], // Initialize as an empty array
    };
  },
  methods: {
    async fetchCampaigns() {
      try {
        const response = await fetch('https://cekkazan-web-be.jsnp.io/api/getCampaigns');
        const data = await response.json();
        const formattedCampaigns = data.results.map(campaign => ({
          ...campaign,
          image: `http://api.cekkazanapp.com${campaign.image}`, // Prepend base URL to image
          start: this.formatDate(campaign.start), // Format start date
          end: this.formatDate(campaign.end), // Format end date
        }));
        this.campaigns = formattedCampaigns;
        localStorage.setItem('campaigns', JSON.stringify(formattedCampaigns)); // Store campaigns in localStorage
      } catch (error) {
        console.error('Error fetching campaigns:', error);
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`; // Return in DD.MM.YYYY format
    },
    goToCampaignDetail(id) {
      this.$router.push(`/campaign/${id}`);
    },
  },
  created() {
    this.fetchCampaigns(); // Fetch campaigns when the component is created
  },
};
</script>

<style>
.home {
  padding-bottom: 2rem; /* Add spacing at the bottom of the page */
  min-height: 55vh;
}

.campaigns {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center; /* Center horizontally */
}
.campaign-card {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 1rem;
  border: 2px solid #ea5610;
  padding: 1rem;
  cursor: pointer;
  text-align: center;
  width: 410px; /* Adjust width for 4.1 aspect ratio */
  height: 220px; /* Increase height to prevent overlap */
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Align content to the top */
  overflow: hidden; /* Prevent content from overflowing */
  position: relative; /* Enable positioning for child elements */
  height: inherit;
}

.campaign-card img {
  width: 100%; /* Ensure the image fills the container width */
  height: 100%; /* Increase height for the image */
  object-fit: cover; /* Crop the image to fit within the container */
}

h2 {
  text-align: center; /* Center the heading horizontally */
  font-family: 'Poppins', sans-serif; /* Use a modern font */
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1.5rem;
}

.campaign-title {
  margin-top: 0.5rem;
  margin-bottom: 1.5rem; /* Increase spacing below the title */
  font-size: 1.2rem;
  font-weight: 500;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  color: #444;
}

.campaign-dates {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 0.9rem;
  color: #666;
  font-family: 'Roboto', sans-serif;
  width: 100%;
}
@media (max-width:991px){
  .campaign-card {
    width: 95%;
  }
  .footer .col-md-4.order-2.order-md-1 {
    display: none;
}
}
</style>
